// SurveyForm->Country, Language
import React, { useState, useEffect, useMemo } from "react";
//i added useMemeo!
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { getData, postData } from "../../FetchNodeServices";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";

const SurveyForm = (props) => {
  const [isActivated, setActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState("");
  const [isFormVisible, setFormVisible] = useState(true);
  const [isSettingsVisible, setSettingsVisible] = useState(false);
  const [isSecurityVisible, setSecurityVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [projectName, setProjectName] = useState("");

  // const [languageId, setlanguageId] = React.useState(""); // Also initialize as an array for multi-select
  const [languageList, setlanguageList] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  const [countryId, setCountryId] = React.useState([]); // Initialize as an array
  const [countryList, setCountryList] = useState([]);
  // const [selectedCountries, setSelectedCountries] = useState([]);

  const [projectCode, setProjectCode] = useState("");
  const navigate = useNavigate();

  const [browserTitle, setBrowserTitle] = useState("");
  const [browserList, setBrowserList] = useState([]);
  //
  const [surveyName, setSurveyName] = useState("");
  const [surveyType, setSurveyType] = useState(0);
  const [surveyTypeId, setSurveyTypeId] = React.useState("");
  const [surveyTypeList, setSurveyTypeList] = useState([]);

  const [SurveyStatus, setSurveyStatus] = useState("");
  const [surveyStatusId, setSurveyStatusId] = React.useState("");
  const [surveyStautsList, setSurveyStatusList] = useState([]);

  // const [progressBar, setProgressBar] = useState(true);
  const [footer, setFooter] = useState(false);
  const [termsPolicy, setTermsPolicy] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [footerContent, setFooterContent] = useState("");
  const [helpLink, setHelpLink] = useState("");
  const [showTermsPolicy, setShowTermsPolicy] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showFooterContent, setShowFooterContent] = useState(false);
  const [showHelpLink, setShowHelpLink] = useState(false);
  const [alert, setAlerts] = useState("");
  const [isTermsPolicyOpen, setIsTermsPolicyOpen] = useState(false);
  const [isFooterContentOpen, setIsFooterContentOpen] = useState(false);
  const [isHelpLinkOpen, setIsHelpLinkOpen] = useState(false);
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  const [isProgressBarOpen, setIsProgressBarOpen] = useState(true);
  const [isFooterOpen, setIsFooterOpen] = useState(false);

  const customer = useSelector((state) => state.user.users[0]);
  const user = useMemo(() => customer?.userId || "", [customer]);

  //

  const [vpnSelection, setVpnSelection] = useState(0);
  const [cookieSelection, setcookieSelection] = useState(0);
  const [duplicateipSelection, setduplicateipSelection] = useState(0);
  const [uniqueipSelection, setuniqueipSelection] = useState(0);
  const [geoipSelection, setgeoipSelection] = useState(0);
  const [errors, setErrors] = useState({});

  const handleToggles = (e) => {
    // Toggle the state
    setIsProgressBarOpen(!isProgressBarOpen);

    // Check the updated state and log the corresponding value
    const newValue = !isProgressBarOpen;
    console.log(newValue, "value");
  };

  const handleFooterToggle = () => {
    setIsFooterOpen(!isFooterOpen);
    const newValue = !isFooterOpen;
    console.log(newValue, "value");
  };

  const handlePrivacyPolicyToggle = () => {
    setIsPrivacyPolicyOpen(!isPrivacyPolicyOpen);
    const newValue = !isPrivacyPolicyOpen;
    console.log(newValue, "value");
  };

  const handleTermsPolicyToggle = () => {
    setIsTermsPolicyOpen(!isTermsPolicyOpen);
    const newValue = !isTermsPolicyOpen;
    console.log(newValue, "value");
  };

  const handleFooterContentToggle = () => {
    setIsFooterContentOpen(!isFooterContentOpen);
    const newValue = !isFooterContentOpen;
    console.log(newValue, "value");
  };

  const handleHelpLinkToggle = () => {
    setIsHelpLinkOpen(!isHelpLinkOpen);
    const newValue = !isHelpLinkOpen;
    console.log(newValue, "value");
  };

  const handleToggle = () => {
    setActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const handleFormToggle = () => {
    setFormVisible(!isFormVisible);
  };

  const handleSettingsToggle = () => {
    setSettingsVisible(!isSettingsVisible);
  };

  const handleSecurityToggle = () => {
    setSecurityVisible(!isSecurityVisible);
  };

  const handleVpnChange = (event) => {
    const value = event.target.value;
    setVpnSelection(value);
    console.log(value); // Logs '1' for Yes and '0' for No
  };
  const handlecookieChange = (event) => {
    const value = event.target.value;
    setcookieSelection(value);
    console.log(value); // Logs '1' for Yes and '0' for No
  };
  const handleduplicateipChange = (event) => {
    const value = event.target.value;
    setduplicateipSelection(value);
    console.log(value); // Logs '1' for Yes and '0' for No
  };
  const handleuniqueipChange = (event) => {
    const value = event.target.value;
    setuniqueipSelection(value);
    console.log(value); // Logs '1' for Yes and '0' for No
  };
  const handlegeoipChange = (event) => {
    const value = event.target.value;
    setgeoipSelection(value);
    console.log(value); // Logs '1' for Yes and '0' for No
  };
  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (!surveyName) {
      isValid = false;
      tempErrors["surveyName"] = "Survey Name is required!";
    }
    if (!surveyStatusId) {
      isValid = false;
      tempErrors["surveyStatus"] = "Survey Status is required!";
    }
    if (!countryId) {
      isValid = false;
      tempErrors["countryId"] = "Country is required!";
    }
    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    if (!handleValidation()) {
      return;
    }
    const formData = {
      userId: user,
      projectName: projectName,
      langIds: selectedLanguages.map((id) => id).join(","),
      projectCode: projectCode,
      surveyName: surveyName,
      surveyType: surveyTypeId,
      surveyStatus: surveyStatusId,
      countryIds: countryId.map((id) => id).join(","),
      surveySetting: {
        userId: user,
        brandingEnabled: 1,
        browserTitle: browserTitle,
        progressBarEnabled: isProgressBarOpen == true ? 1 : 0,
        footerEnabled: isFooterOpen == true ? 1 : 0,
        helpLinkEnabled: isHelpLinkOpen == true ? 1 : 0,
        helpLink: helpLink,
        termsConditionsEnabled: isTermsPolicyOpen == true ? 1 : 0,
        termsConditions: termsPolicy,
        privacyPolicyEnabled: isPrivacyPolicyOpen == true ? 1 : 0,
        privacyPolicy: privacyPolicy,
        footerContentEnabled: isFooterContentOpen == true ? 1 : 0,
        footerContent: footerContent,
      },
      surveySecurity: {
        userId: user,
        deviceEnabled: 1,
        deviceAllowed: "yes",
        browserEnabled: 0,
        browserAllowed: "yes",
        surveySpeedersEnabled: 0,
        timestampSsMinTime: "10",
        timestampSsMaxTime: "5",
        queSpeedersEnabled: 0,
        timestampQsMinTime: "7",
        timestampQsMaxTime: "8",
        geoIpEnabled: geoipSelection,
        uniqueIpEnabled: uniqueipSelection,
        duplicateIdEnabled: duplicateipSelection,
        reEntryEnabled: 1,
        cookieEnabled: cookieSelection,
        proxyVpnEnabled: vpnSelection,
        captureRespondentPhotoEnabled: 1,
        captureRespondentVideoEnabled: 1,
        digitalFingerPrintingEnabled: 0,
        backButtonEnabled: 1,
        otpEnabled: 1,
        otpSmsEnabled: 1,
        otpEmailEnabled: 1,
        otpCallEnabled: 0,
        printScreenEnabled: 1,
        sourceCodeEnabled: 0,
        imageVideoDownloadingEnabled: 1,
      },
    };

    setIsLoading(true);
    try {
      const result = await postData("users/add-survey", formData);
      // const result = formData;
      console.log("Survey Created successfully:", result);
      const myData = countryId.map((id) => id).join(",");
      console.log("myData ------>", myData);
      setAlerts([
        { variant: "sucess", heading: "Survey Created Successfully! " },
      ]);
      navigate("/survey-listing"); // Redirect to survey listing or desired page
    } catch (error) {
      console.error("Error submitting form:", error);
      // Handle error response here, e.g., show an error message
    } finally {
      setIsLoading(false);
    }
  };

  const handleCountryChange = (selectedOptions) => {
    if (selectedOptions && Array.isArray(selectedOptions)) {
      const selectedIds = selectedOptions.map((option) => option.value);
      setCountryId(selectedIds); // Update state with the selected country IDs as an array
    } else {
      setCountryId([]); // If no options are selected, set state to an empty array
    }
  };
  console.log("countries", countryId);

  // const handleLanguageChange = (selectedOptions) => {
  //   if (selectedOptions && Array.isArray(selectedOptions)) {
  //     const selectedIds = selectedOptions.map(option => option.value);
  //     setSelectedLanguages(selectedIds); // Update state with the selected language IDs as an array
  //   } else {
  //     setSelectedLanguages([]); // If no options are selected, set state to an empty array
  //   }
  // };

  const handleLanguageChange = (selectedOptions = []) => {
    // Use default parameter to handle undefined selectedOptions
    const selectedIds = selectedOptions.map((option) => option.value);
    setSelectedLanguages(selectedIds); // Update state with the selected language IDs
  };

  console.log("language", selectedLanguages);

  const handleSurveyTypeChange = (selectedOption) => {
    setSurveyTypeId(selectedOption.value);
  };

  const handleSurveyStatusChange = (selectedOption) => {
    setSurveyStatusId(selectedOption.value);
  };

  const fetchCountry = async () => {
    setIsLoading(true);
    let result = await getData("users/country");
    setCountryList(result);
    setIsLoading(false);
  };

  const fetchLanguage = async () => {
    setIsLoading(true);
    let result = await getData("users/country/language");
    setlanguageList(result);
    setIsLoading(false);
  };

  const fetchSurveyType = async () => {
    setIsLoading(true);
    let result = await getData("users/survey-types");
    setSurveyTypeList(result);
    setIsLoading(false);
  };

  const fetchSurveyStatus = async () => {
    setIsLoading(true);
    let result = await getData("users/survey-status");
    setSurveyStatusList(result);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchCountry();
    fetchLanguage();
    fetchSurveyType();
    fetchSurveyStatus();
  }, []);

  // const fillCountry = () => {
  //   return countryList.map((item) => {
  //     return { value: item.countryId, label: item.countryName };
  //   });
  // };

  const fillCountry = () => {
    return countryList
      .filter((item) => item.countryId && item.countryName) // Ensure both values are present
      .map((item) => ({
        value: item.countryId,
        key: item.countryName,
      }));
  };

  const fillLanguage = () => {
    return languageList
      .filter((item) => item.langId && item.language) // Ensure both values are present
      .map((item) => ({
        value: item.langId,
        key: item.language, // 'key' is used by Multiselect for display
        cat: "Languages",
      }));
  };

  const fillSurveyType = () => {
    return surveyTypeList.map((item) => {
      return { value: item.genericValueId, label: item.genericValue };
    });
  };

  const fillSurveyStatus = () => {
    return surveyStautsList.map((item) => {
      return { value: item.genericValueId, label: item.genericValue };
    });
  };

  // const handleLanguageRemove = (selectedList, removedItem) => {
  //   const selectedIds = selectedList.map(option => option.value);
  //   setSelectedLanguages(selectedIds); // Update state with the remaining language IDs
  // };
  const handleLanguageRemove = (selectedList = []) => {
    // Similarly, handle empty selectedList
    const selectedIds = selectedList.map((option) => option.value);
    setSelectedLanguages(selectedIds); // Update state with remaining language IDs
  };
  const handleCountryRemove = (selectedList, removedItem) => {
    const selectedIds = selectedList.map((option) => option.value);
    setCountryId(selectedIds); // Update state with the remaining language IDs
  };

  const handleClear = () => {
    setProjectName("");
    setSelectedLanguages([]);
    setProjectCode("");
    setBrowserTitle("");
    setSurveyName("");
    setSurveyType("");
    setSurveyStatus("");
    setCountryId([]);
    setIsProgressBarOpen(false);
    setFooter(false);
    setTermsPolicy("");
    setPrivacyPolicy("");
    setFooterContent("");
    setHelpLink("");
    setShowTermsPolicy(false);
    setShowPrivacyPolicy(false);
    setShowFooterContent(false);
    setShowHelpLink(false);
    setgeoipSelection("");
    setuniqueipSelection("");
    setduplicateipSelection("");
    setcookieSelection("");
    setVpnSelection("");
  };
  const renderPlaceholderText = () => {
    const selectedCount = countryId.length;

    if (selectedCount === 0) {
      return 'Select Country'; // Default placeholder
    } else if (selectedCount > 3) {
      return `${selectedCount} Countries Selected`; // When more than 3 countries are selected
    } else {
      return ''; // No placeholder when 3 or fewer countries are selected
    }
  };

  const renderPlaceholderLanguageText = () => {
    const selectedCount = selectedLanguages.length;

    if (selectedCount === 0) {
      return 'Select Languages'; // Default placeholder
    } else if (selectedCount > 3) {
      return `${selectedCount} selected`; // When more than 4 languages are selected
    } else {
      return ''; // No placeholder when 4 or fewer languages are selected
    }
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {Object.keys(errors).length > 0 && (
          <div className="error-summary">
            <ul>
              {Object.values(errors).map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="container-fluid py-3">
          <div className="row">
            <div className="col-lg-9">
              <div className="card border-light-subtle">
                <ul className="nav nav-pills custom-nav-pills custom-background custom-navbar-height ">
                  <li className="nav-item ">
                    {/* <Link to="/survey-form">
                      {" "}
                      <a
                        className="nav-link active survey-form"
                        aria-current="page"
                        href="#"
                      >
                        Survey Form
                      </a>
                    </Link> */}
                    <Link
                      to="/survey-form"
                      className="nav-link active "
                      aria-current="page"
                    >
                      {" "}
                      Survey Form
                    </Link>
                  </li>
                  <li className="nav-item">
                    {/* <Link to="/survey-programming">
                      <a className="nav-link survey-form" href="#">
                        Questions
                      </a>
                    </Link> */}
                    <Link to="/survey-form" className="nav-link  ">
                      {" "}
                      Questions
                    </Link>
                  </li>
                  <li className="nav-item">
                    {/* <Link to="/view-quota">
                      <a className="nav-link" href="#">
                        Quota
                      </a>
                    </Link> */}
                    <Link to="/survey-form" className="nav-link  ">
                      {" "}
                      Quota
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Field Work</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Survey Data</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Stats</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Analysis</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link ">Reports</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <Link to="/survey-form">
                <li>
                  <i className="bi bi-people"></i> Survey Form
                </li>
              </Link>
            </ul>
          </div>
          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <h6 className="font-style">
                Basic Details
                <span
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={handleFormToggle}
                >
                  <i
                    className={`bi ${isFormVisible ? "bi-chevron-down" : "bi-chevron-right"
                      }`}
                  ></i>
                </span>
              </h6>
              <br />
              {isFormVisible && (
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Project Name</label>
                      <input
                        type="text"
                        value={projectName}
                        className="form-control"
                        placeholder="Project Name"
                        onChange={(event) => setProjectName(event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="languageSelect">Language</label>
                      {/* Wants hide Clips After Languages are Selected */}
                      <Multiselect
                        id="languageSelect"
                        options={fillLanguage()} // Populate options from the function
                        selectedValues={selectedLanguages.map(
                          (id) =>
                            fillLanguage().find(
                              (option) => option.value === id
                            ) || { value: id, key: "Unknown Language" }
                        )}
                        // Map selected language IDs to options, fallback to 'Unknown Language' if not found
                        displayValue="key" // Display the 'key' property as the label in the dropdown
                        onSelect={handleLanguageChange} // Handle selection changes
                        onRemove={handleLanguageRemove} // Handle removal of selected languages
                        showCheckbox // Show checkboxes for multiple selection
                        placeholder={
                          selectedLanguages.length > 4
                            ? selectedLanguages.length + " selected"
                            : "Select Languages"
                        }
                        // Display number of selected languages or placeholder text
                        isLoading={isLoading} // Show loading state if options are being fetched
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Project Code</label>
                      <input
                        type="text"
                        value={projectCode}
                        className="form-control"
                        placeholder="Project Code"
                        onChange={(event) => setProjectCode(event.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Browser Title </label>
                      <input
                        type="text"
                        value={browserTitle}
                        className="form-control"
                        placeholder="Browser Title"
                        onChange={(event) =>
                          setBrowserTitle(event.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Survey Name</label>
                      <input
                        type="text"
                        value={surveyName}
                        className="form-control"
                        placeholder="Survey Name"
                        onChange={(event) => setSurveyName(event.target.value)}
                      />
                      {errors.surveyName && (
                        <span className="text-danger">{errors.surveyName}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Survey Type</label>

                      <Select
                        options={fillSurveyType()}
                        value={fillSurveyType().find(
                          (option) => option.value === surveyTypeId
                        )}
                        onChange={handleSurveyTypeChange}
                        placeholder="Select Survey Type"
                        isSearchable
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Survey Status</label>

                      <Select
                        options={fillSurveyStatus()}
                        value={fillSurveyStatus().find(
                          (option) => option.value === surveyStatusId
                        )}
                        onChange={handleSurveyStatusChange}
                        placeholder="Select Survey Status"
                        isSearchable
                      />
                      {errors.surveyStatus && (
                        <span className="text-danger">
                          {errors.surveyStatus}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">Country</label>
                      <Multiselect
                        id="countrySelect"
                        options={fillCountry()}
                        selectedValues={countryId.map((id) =>
                          fillCountry().find((option) => option.value === id)
                        )}
                        displayValue="key"
                        onSelect={handleCountryChange}
                        onRemove={handleCountryRemove}
                        showCheckbox
                        placeholder={countryId.length > 4
                          ? countryId.length + " selected"
                          : "Select Countries"
                        }
                        isLoading={isLoading}
                      />

                      {errors.countryId && (
                        <span className="text-danger">{errors.countryId}</span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <br />
          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <h6 className="font-style">
                Basic Settings
                <span
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={handleSettingsToggle}
                >
                  <i
                    className={`bi ${isSettingsVisible ? "bi-chevron-down" : "bi-chevron-right"
                      }`}
                  ></i>
                </span>
              </h6>
              <br />
              {isSettingsVisible && (
                <div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="d-flex align-items-center mb-3 ">
                        <label className="me-2">Progress Bar:</label>

                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            checked={isProgressBarOpen}
                            onChange={handleToggles}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckChecked"
                          ></label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="d-flex align-items-center mb-3">
                        <label className="me-2">Footer:</label>

                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            checked={isFooterOpen}
                            onChange={handleFooterToggle}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckChecked"
                          ></label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {isFooterOpen && (
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group mb-4 d-flex align-items-center">
                          <label htmlFor="">Terms & Policy</label>
                          <div className="form-check form-switch ms-auto">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="termsPolicyOpen"
                              checked={isTermsPolicyOpen}
                              onChange={handleTermsPolicyToggle}
                            />
                          </div>
                        </div>
                        {isTermsPolicyOpen && (
                          <div className="form-group mb-4">
                            <input
                              type="text"
                              value={termsPolicy}
                              className="form-control mt-2"
                              placeholder="Terms & Policy"
                              onChange={(event) =>
                                setTermsPolicy(event.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group mb-4 d-flex align-items-center">
                          <label htmlFor="">Privacy Policy</label>
                          <div className="form-check form-switch ms-auto">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="privacyPolicyOpen"
                              checked={isPrivacyPolicyOpen}
                              onChange={handlePrivacyPolicyToggle}
                            />
                          </div>
                        </div>
                        {isPrivacyPolicyOpen && (
                          <div className="form-group mb-4">
                            <input
                              type="text"
                              value={privacyPolicy}
                              className="form-control mt-2"
                              placeholder="Privacy Policy"
                              onChange={(event) =>
                                setPrivacyPolicy(event.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group mb-4 d-flex align-items-center">
                          <label htmlFor="">Footer Content</label>
                          <div className="form-check form-switch ms-auto">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="footerContentOpen"
                              checked={isFooterContentOpen}
                              onChange={handleFooterContentToggle}
                            />
                          </div>
                        </div>
                        {isFooterContentOpen && (
                          <div className="form-group mb-4">
                            <input
                              type="text"
                              value={footerContent}
                              className="form-control mt-2"
                              placeholder="Footer Content"
                              onChange={(event) =>
                                setFooterContent(event.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group mb-4 d-flex align-items-center">
                          <label htmlFor="">Help Link</label>
                          <div className="form-check form-switch ms-auto">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="helpLinkOpen"
                              checked={isHelpLinkOpen}
                              onChange={handleHelpLinkToggle}
                            />
                          </div>
                        </div>
                        {isHelpLinkOpen && (
                          <div className="form-group mb-4">
                            <input
                              type="text"
                              value={helpLink}
                              className="form-control mt-2"
                              placeholder="Help Link"
                              onChange={(event) =>
                                setHelpLink(event.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <br />
          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <h6 className="font-style">
                Security Options
                <span
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={handleSecurityToggle}
                >
                  <i
                    className={`bi ${isSecurityVisible ? "bi-chevron-down" : "bi-chevron-right"
                      }`}
                  ></i>
                </span>
              </h6>
              <br />
              {isSecurityVisible && (
                <>
                  <div className="row">
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">GeoIP</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="geoipCheckboxYes"
                            value="1"
                            checked={geoipSelection === "1"}
                            onChange={handlegeoipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="geoipCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="geoipCheckboxNo"
                            value="0"
                            checked={geoipSelection === "0"}
                            onChange={handlegeoipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="geoipCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">Unique IP</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="uniqueipCheckboxYes"
                            value="1"
                            checked={uniqueipSelection === "1"}
                            onChange={handleuniqueipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="uniqueipCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="uniqueipCheckboxNo"
                            value="0"
                            checked={uniqueipSelection === "0"}
                            onChange={handleuniqueipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="uniqueipCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">Duplicate Id</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="duplicateipCheckboxYes"
                            value="1"
                            checked={duplicateipSelection === "1"}
                            onChange={handleduplicateipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="duplicateipCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="duplicateipCheckboxNo"
                            value="0"
                            checked={duplicateipSelection === "0"}
                            onChange={handleduplicateipChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="duplicateipCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">Cookie</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="cookieCheckboxYes"
                            value="1"
                            checked={cookieSelection === "1"}
                            onChange={handlecookieChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cookieipCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="cookieipCheckboxNo"
                            value="0"
                            checked={cookieSelection === "0"}
                            onChange={handlecookieChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="cookieipCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group mb-4">
                        <p className="mb-2">Proxy/VPN</p>

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="vpnCheckboxYes"
                            value="1"
                            checked={vpnSelection === "1"}
                            onChange={handleVpnChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="vpCheckboxYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="vpCheckboxNo"
                            value="0"
                            checked={vpnSelection === "0"}
                            onChange={handleVpnChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="vpCheckboxNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Repeat similar structure for other security options */}
                  </div>

                  <br />
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                        type="button"
                        className="btn bg-danger-subtle text-danger"
                        onClick={() => handleClear()}
                      >
                        Clear Values
                      </button>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleSubmit();
                        }}
                      >
                        {/* Form fields here */}
                        <button
                          type="button"
                          className="btn btn-success px-4"
                          onClick={handleSubmit}
                        >
                          {isLoading ? "Submitting..." : "Create Survey"}
                        </button>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyForm;
